import { ErrorEntity } from '../../root/context';

export type OfferConflictField = 'customer.mail' | 'customer.name';

/** Conflicts the error modal leaves out – the offer UI shows them itself, worded for the admin. */
export const OFFER_CONFLICTS: Partial<Record<ErrorEntity, { field: OfferConflictField; message: string }>> = {
  [ErrorEntity.OfferMailAlreadyInUseConflict]: {
    field: 'customer.mail',
    message: 'Diese E-Mail gehört schon zu einem Nutzer, einer Einladung, einer Self-Checkout-Anfrage oder einem offenen Angebot.'
  },
  [ErrorEntity.OfferCompanyNameAlreadyInUseConflict]: {
    field: 'customer.name',
    message: 'Diese Firma gehört schon zu einem Kunden, einer Einladung, einer Self-Checkout-Anfrage oder einem offenen Angebot.'
  }
};
